<template>
  <div class="col-12 col-xl-12 ">
    <div class="card mb-3 mb-xxl-5 me-xxl-4" style="margin-top: 4rem; overflow: visible">
      <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2" style="height: 60px">
        <div class="bg-gradient-primary shadow-primary border-radius-lg pt-4 pb-3 h-100">
          <h6 class="text-white text-capitalize ps-3 pe-3">{{ $t('studentTable.title') }}</h6>
        </div>
      </div>

      <div class="card-body px-0 pb-0 pb-2 pe-xl-3">
        <div class="table-responsive p-1 p-xl-4">
          <LoadingSpinner 
            v-if="loading" 
            :message="$t('studentTable.loadingMsg')"
            class="py-3 py-5"
          />

          <template v-else>
            <div class="d-block d-xl-none" :dir="direction">
              <div v-if="!loading && students.length === 0" class="text-center py-3 text-muted">
                <i class="fas fa-user-graduate fa-2x mb-2"></i>
                <p>{{ $t('studentTable.noStudents') }}</p>
              </div>

              <div v-for="student in students" :key="'mobile-' + student.id" class="card mb-3 mx-2">
                <div class="card-body py-2">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <p class="text-xs text-muted mb-0">{{ $t('studentTable.id') }}: {{ student.id }}</p>
                      <h6 class="mb-0 text-sm">
                        {{ student.first_name }} {{ student.father_name }} {{ student.last_name }}
                      </h6>
                      <p class="text-xs text-muted mb-0">
{{ student.national_num || student.passport_num || "—" }}
                      </p>
                    </div>
                    <div>
                      <span class="badge badge-sm" :class="student.gender === 'M' ? 'bg-primary' : 'bg-secondary'">
                        {{ student.gender === "M" ? $t('studentTable.male') : $t('studentTable.female') }}
                      </span>
                    </div>
                  </div>
                  
                  <div class="mt-2">
                    <p class="text-xs mb-1" v-if="student.class_groups && student.class_groups.length">
                      <span class="font-weight-bold">{{ student.class_groups[0].class.name }}</span>
                      <span v-if="student.class_groups[0].group" class="text-muted">
                        ({{ student.class_groups[0].group.name }})
                      </span>
                    </p>
                    <p class="text-xs text-muted mb-1" v-else>{{ $t('studentTable.notEnrolled') }}</p>
                  </div>
                  
                  <div class="d-flex justify-content-between align-items-center mt-2">
                    <span class="badge badge-sm bg-gradient-success">
                      <i class="fas fa-check-circle me-1"></i>
                      {{ $t('studentTable.active') }}
                    </span>
                    
                    <div class="d-inline-flex">
                      
                      <button
                        @click.stop="viewStudentDetails(student.id)"
                        class="btn btn-link text-primary p-0 mx-1"
                        :title="$t('studentTable.details')"
                        v-can="'students.display'"
                      >
                        <i class="fas fa-eye fa-xs"></i>
                      </button>
                      <button
  @click.stop="viewRewardHistory(student.id)"
  class="btn btn-link text-warning p-1 mx-1"
  :title="$t('studentTable.reward_history')"
  v-can="'student_rewards.display'"
>
  <i class="fas fa-star fa-sm"></i>
</button>
                           <button
                  @click.stop="viewAcademicHistory(student.id)"
                  class="btn btn-link text-success p-0 mx-1"
                  :title="$t('studentTable.academic_history')"
                  v-can="'students.display'"
                >
                  <i class="fas fa-graduation-cap fa-xs"></i>
                </button>
                      <router-link
                        :to="{ name: 'students.guardians', params: { id: student.id } }"
                        class="btn btn-link text-info p-0 mx-1"
                        :title="$t('studentTable.guardians')"
                        v-can="'student_guardians.display'"
                      >
                        <i class="fas fa-users fa-xs"></i>
                      </router-link>
                      <button
                        @click.stop="navigateToEditStudent(student.id)"
                        class="btn btn-link text-secondary p-0 mx-1"
                        :title="$t('studentTable.edit')"
                        v-can="'students.update'"
                      >
                        <i class="fas fa-edit fa-xs"></i>
                      </button>
                      <button
                        @click.stop="openDeleteDialog(student.id, `${student.first_name} ${student.father_name}`)"
                        class="btn btn-link text-danger p-0 mx-1"
                        :title="$t('studentTable.delete')"
                        v-can="'students.delete'"
                      >
                        <i class="fas fa-trash fa-xs"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <table class="table align-items-center mb-0 d-none d-xl-table" :dir="direction">
              <thead>
                <tr>
                                    <th class="text-uppercase text-xxs font-weight-bolder opacity-7">{{ $t('studentTable.id') }}</th>

                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7">{{ $t('studentTable.name') }}</th>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7">{{ $t('studentTable.nationalOrPassport') }}</th>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-center">{{ $t('studentTable.gender') }}</th>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-center">{{ $t('studentTable.class') }}</th>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-center">{{ $t('studentTable.status') }}</th>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-center pe-4">{{ $t('studentTable.actions') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!loading && students.length === 0">
                  <td colspan="6" class="text-center py-4 text-muted">
                    <i class="fas fa-user-graduate fa-2x mb-2"></i>
                    <p>{{ $t('studentTable.noStudents') }}</p>
                  </td>
                </tr>
                
                <template v-if="!loading">
                  <tr v-for="student in students" :key="student.id">
                          <td>
                      <div class="d-flex px-3 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-md">
                            {{ student.id }} 
                          </h6>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex px-3 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-md">
                            {{ student.first_name }} {{ student.father_name }} {{ student.last_name }}
                          </h6>
                        </div>
                      </div>
                    </td>
                    <td>
                      <p class="text-xs font-weight-bold mb-0">
{{ student.national_num || student.passport_num || "—" }}
                      </p>
                      <p class="text-xs text-secondary mb-0">
                        {{ student.nationality?.name }}
                      </p>
                    </td>
                    <td class="align-middle text-center">
                      <span
                        class="badge badge-sm"
                        :class="student.gender === 'M' ? 'bg-primary' : 'bg-secondary'"
                      >
                        {{ student.gender === "M" ? $t('studentTable.male') : $t('studentTable.female') }}
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <template v-if="student.class_groups && student.class_groups.length">
                        <p class="text-xs font-weight-bold mb-0">
                          {{ student.class_groups[0].class.name }}
                          <span
                            v-if="student.class_groups[0].group"
                            class="text-xs text-secondary"
                          >
                            ({{ student.class_groups[0].group.name }})
                          </span>
                        </p>
                        <p class="text-xs text-secondary mb-0">
                          {{ formatDate(student.class_groups[0].date) }}
                        </p>
                      </template>
                      <span v-else class="text-xs text-secondary">{{ $t('studentTable.notEnrolled') }}</span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="badge badge-sm bg-gradient-success">
                        <i class="fas fa-check-circle me-1"></i>
                        {{ $t('studentTable.active') }}
                      </span>
                    </td>
                    <td class="align-middle text-end pe-4">
                      <div class="d-inline-flex">
                        <button
                          @click.stop="viewStudentDetails(student.id)"
                          class="btn btn-link text-primary p-1 mx-1"
                          :title="$t('studentTable.details')"
                          v-can="'students.display'"
                        >
                          <i class="fas fa-eye fa-sm"></i>
                        </button>
                        <button
  @click.stop="viewRewardHistory(student.id)"
  class="btn btn-link text-warning p-1 mx-1"
  :title="$t('studentTable.reward_history')"
  v-can="'student_rewards.display'"
>
  <i class="fas fa-star fa-sm"></i>
</button>
                           <button
                        @click.stop="viewAcademicHistory(student.id)"
                        class="btn btn-link text-success p-1 mx-1"
                        :title="$t('studentTable.academic_history')"
                        v-can="'students.display'"
                      >
                        <i class="fas fa-graduation-cap fa-sm"></i>
                      </button>
                        <router-link
                          :to="{ name: 'students.guardians', params: { id: student.id } }"
                          class="btn btn-link text-info p-1 mx-1"
                          :title="$t('studentTable.guardians')"
                          v-can="'student_guardians.display'"
                        >
                          <i class="fas fa-users fa-sm"></i>
                        </router-link>
                        <button
                          @click.stop="navigateToEditStudent(student.id)"
                          class="btn btn-link text-secondary p-1 mx-1"
                          :title="$t('studentTable.edit')"
                          v-can="'students.update'"
                        >
                          <i class="fas fa-edit fa-sm"></i>
                        </button>
                        <button
                          @click.stop="openDeleteDialog(student.id, `${student.first_name} ${student.father_name}`)"
                          class="btn btn-link text-danger p-1 mx-1"
                          :title="$t('studentTable.delete')"
                          v-can="'students.delete'"
                        >
                          <i class="fas fa-trash fa-sm"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, watch, computed } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import LoadingSpinner from '@/components/common/LoadingSpinner.vue';
const direction = computed(() => (locale.value === "ar" ? "rtl" : "ltr"));

const {  locale } = useI18n();

defineProps({
  students: {
    type: Array,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(["edit", "delete"]);
const router = useRouter();

const openDeleteDialog = (studentId, studentName) => {
  emit("delete", studentId, studentName);
};
const viewAcademicHistory = (studentId) => {
  router.push(`/students/${studentId}/academic-history`);
};

const navigateToEditStudent = (studentId) => {
  router.push(`/students/${studentId}/edit`);
};

const viewStudentDetails = (studentId) => {
  router.push(`/students/${studentId}`);
};
const viewRewardHistory = (studentId) => {
  router.push(`/students/${studentId}/reward-history`);
}
watch(locale, (newLocale) => {
  document.body.setAttribute('dir', newLocale === 'ar' ? 'rtl' : 'ltr');
});

const formatDate = (dateString) => {
  if (!dateString) return "";
  const options = { year: "numeric", month: "long", day: "numeric" };
  return new Date(dateString).toLocaleDateString(locale.value || "ar", options);
};
</script>
<style scoped>
[dir="ltr"] .text-end {
  text-align: right !important;
}
[dir="rtl"] .text-end {
  text-align: left !important;
}</style>